const ALPHANUMERIC_CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

/**
 * Generates a random alphanumeric ID of the specified length.
 * @param length The length of the alphanumeric ID to be generated.
 * @returns A random alphanumeric ID.
 */
const generateAlphaNumericId = (length: number): string => {
  const charactersLength = ALPHANUMERIC_CHARACTERS.length
  let result = ''

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength)
    result += ALPHANUMERIC_CHARACTERS.charAt(randomIndex)
  }

  return result
}

export default generateAlphaNumericId
